import { Reducer } from "redux";
import { ActionPayload } from "../../types";

interface ReducerHandler {
  [key: string]: any;
}

type CustomReducer = <S>(
  state: S,
  handlers: ReducerHandler
) => Reducer<S, ActionPayload<any>>;

const createReducer: CustomReducer =
  (initialState, handlers) =>
  (state = initialState, action) => {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };

export default createReducer;
